import React, { Component } from "react";

import { Divide as Hamburger } from "hamburger-react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  Link,
} from "react-router-dom";
import ReactGA from "react-ga4";

export default class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }
  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }
  handleResize = () => {
    this.setOpen(false);
  };
  setOpen(force = true) {
    if (!force) {
      this.setState((prevState) => ({
        isOpen: false,
      }));
      return;
    }
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
    }));
  }

  triggerMenuClick = (func = "goto", type = "") => {
   ReactGA.event({
      category: "keno_2024",
      action: "click",
      label: type,
    });

    if (func === "modal") {
      this.props.modal(type);
    } else {
      this.props.goTo(type);
      if (type === "wincar") {
        this.props.modal(type);
      }else{
       
      }
  
    }
    this.setOpen(false);
   
  };

  render() {
    const { isOpen } = this.state;
    const { language } = this.props;
    return (
      <div className="nav">
        <div className="nav--inside">
          <div className={`menu ${isOpen ? "is-open" : ""}`}>
            <button onClick={() => this.triggerMenuClick("goto", "campaign")}>
              {language === "et" ? "Kampaania info" : "O кампании"}
            </button>
            <button onClick={() => this.triggerMenuClick("modal", "rules")}>
              {language === "et" ? "Reeglid" : "Правила"}
            </button>
            <button onClick={() => this.triggerMenuClick("goto", "winners")}>
              {language === "et" ? "Võitjad" : "Победители "}
            </button>
            <button
              onClick={() =>
                this.props.changeLanguage(language === "et" ? "ru" : "et")
              }
            >
              {language === "et" ? (
                <Link to="/ru">RUS</Link>
              ) : (
                <Link to="/et">EST</Link>
              )}
            </button>
          </div>
          {isOpen && (
            <div
              className="closeMenu"
              onClick={() => this.setOpen(false)}
            ></div>
          )}
          <Hamburger
            size={20}
            distance="sm"
            color="#FFFFFF"
            toggled={isOpen}
            toggle={() => this.setOpen()}
          />
        </div>
      </div>
    );
  }
}
